<template>
  <div>
    <div class="page-header clear-filter" filter-color="">
      <parallax
        class="page-header-image"
        style="background-image:url('img/welding.png')"
      >
      </parallax>
      <div class="container">
        <h2 class="title mt-5">{{ $t('common.offices.productServices') }}</h2>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 section section-tabs">
            <div class="container">
              <h5 class="text-dark font-weight-bold mb-5 text-center">
                <img
                  src="img/icon/icon (7).png" alt=""
                  width="20%"
                  class="ml-3 mr-3 mb-3"
                /><br>
                <span style="color: green;">{{ $t('detailProductPiping.sidebar.title') }}</span>
              </h5>
              <router-link to="/detail-product-vessel">
                <div class="card p-3 cards">
                  {{ $t('detailProductPiping.sidebar.vessel') }}
                </div>
              </router-link>
              <router-link to="/detail-product-he">
                <div class="card p-3 cards">
                  {{ $t('detailProductPiping.sidebar.heatExchanger') }}
                </div>
              </router-link>
              <router-link to="/detail-product-piping">
                <div class="card p-3 cards">
                  {{ $t('detailProductPiping.sidebar.piping') }}
                </div>
              </router-link>
              <router-link to="/detail-product-tower">
                <div class="card p-3 cards">
                  {{ $t('detailProductPiping.sidebar.tower') }}
                </div>
              </router-link>
              <router-link to="/detail-product-mufle">
                <div class="card p-3 cards">
                  {{ $t('detailProductPiping.sidebar.muffle') }}
                </div>
              </router-link>
              <router-link to="/detail-product-radiant">
                <div class="card p-3 cards">
                  {{ $t('detailProductPiping.sidebar.radiantTube') }}
                </div>
              </router-link>
              <router-link to="/detail-product-other">
                <div class="card p-3 cards">
                  {{ $t('detailProductPiping.sidebar.otherEquipment') }}
                </div>
              </router-link>
            </div>
          </div>
          <div class="col-lg-9">
            <div class="hero-image-wrap">
              <img
              src="img/detail_product/piping/Titanium Gr. 2 Spool Piping (4).jpg"
              class="rounded animated fadeInDown"
              width="100%"
              height="40%" :alt="$t('detailProductPiping.pageTitle')"
            />
            </div>
            <h2 class="mt-4 text-dark">{{ $t('detailProductPiping.fabricationOf') }} <span style="color: green;" class="font-weight-bold">{{ $t('detailProductPiping.product.name') }}</span></h2>
            <h5>{{ $t('detailProductPiping.product.desc') }}</h5>

            <!-- <h4 class="text-dark font-weight-bold">Fabrication of Piping</h4>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
            consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
            proident, sunt in culpa qui officia deserunt mollit anim id est laborum. <br><br>

            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
            consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
            proident, sunt in culpa qui officia deserunt mollit anim id est laborum. -->

            <div class="col-md-10 ml-auto mr-auto mt-5">
              <div class="photo-grid mt-5 mb-4">
                <div class="photo-tile">
                  <img src="img/detail_product/piping/Titanium Gr. 2 Spool Piping (4).jpg" alt="Titanium Gr. 2 Spool Piping" />
                  <span class="photo-caption">Titanium Gr. 2 Spool Piping</span>
                </div>
                <div class="photo-tile">
                  <img src="img/detail_product/piping/Titanium Gr. 2 Spool Piping (3).jpg" alt="Titanium Gr. 2 Spool Piping" />
                  <span class="photo-caption">Titanium Gr. 2 Spool Piping</span>
                </div>
                <div class="photo-tile">
                  <img src="img/detail_product/piping/Titanium Gr. 2 Spool Piping (2).jpg" alt="Titanium Gr. 2 Spool Piping" />
                  <span class="photo-caption">Titanium Gr. 2 Spool Piping</span>
                </div>
                <div class="photo-tile">
                  <img src="img/detail_product/piping/Alloy C276 N10276 Spool Piping.jpg" alt="Alloy C276 N10276 Spool Piping" />
                  <span class="photo-caption">Alloy C276 N10276 Spool Piping</span>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <!-- MOTO TOKKI  -->
    <div class="page-header clear-filter moto-office-section" filter-color="purple">
      <div class="parallax">
        <div class="container" style="">
          <h1 class="text-white text-left pt-5 font-weight-bold text-center">START <span style="font-size: 20px; color: yellow;"> {{ $t('common.offices.motoStartWithTokki') }} </span></h1>
          <div class="row pt-5 mt-n4">
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.mainOfficeFactory') }}</span></h6>
              Kawasan Industri Jababeka 1
              Jl.Jababeka XIIB Blok W26
              Cikarang-Bekasi, Jawa Barat Indonesia Kode Pos 17530
              Telp: +62-21 893 6733 (Hunting) <br><br>

              Phone : +62 - 21 8936733 (Hunting)<br>
              Fax   : +62 - 21 8936738<br>
              Email : sales@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.secondOfficeFactory') }}</span></h6>
              Kawasan Industri Krakatau 1,
              Jl. Australia I Kav. C1/2, Kel. Warnasari, Kec. Citangkil
              Kota Cilegon, Banten - Indonesia 42443 <br><br>

              Phone : +62 - 254 8317244<br>
              Fax   : +62 - 254 8317244<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.thirdOfficeFactory') }}</span></h6>
              Pergudangan AKR GEM City F-09, Kabupaten Gresik, Jawa Timur <br><br><br>

              Phone : +62 - 31 39935914<br>
              Fax   : +62 - 31 39935914<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left mb-5">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.fourthMarketingOffice') }}</span></h6>
              Jl. Gn. Leuser, Tj. Marulak, Kec. Rambutan, Kota Tebing Tinggi, Sumatera Utara 20998 <br><br><br>

              Phone : +62 811-1972-2507<br>
              Email : sales@tef.co.id<br>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui';

export default {
  name: 'profile',
  bodyClass: 'profile-page',
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  methods: {
    toDetailProduct(param){
      this.$router.push('/detail-product/'+param)
    }
  }
};
</script>
<style>
   .animated {
     
      padding-top:0px;
      margin-bottom:0px;
      -webkit-animation-duration: 5s;
      animation-duration: 5s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
   }
   
   @-webkit-keyframes fadeInDown {
      0% {
         opacity: 0;
         -webkit-transform: translateY(-20px);
      }
      100% {
         opacity: 1;
         -webkit-transform: translateY(0);
      }
   }
   
   @keyframes fadeInDown {
      0% {
         opacity: 0;
         transform: translateY(-50px);
      }
      100% {
         opacity: 1;
         transform: translateY(0);
      }
   }
   
   .fadeInDown {
      -webkit-animation-name: fadeInDown;
      animation-name: fadeInDown;
   }


  .cards {
    transition: all 0.25s ease;
    border-left: 3px solid transparent;
  }

  .cards:hover{
    background: #f4f9f6;
    border-left: 3px solid #008c45;
    transform: translateX(4px);
    box-shadow: 0 4px 14px rgba(0,0,0,0.08);
    cursor: pointer;
  }

  .hero-image-wrap {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }

  .hero-image-wrap img {
    width: 100%;
    display: block;
  }

  .photo-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 20px;
  }

  .photo-tile {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
    aspect-ratio: 4 / 3;
  }

  .photo-tile img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.45s ease;
    display: block;
  }

  .photo-tile:hover img {
    transform: scale(1.08);
  }

  .photo-caption {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 32px 14px 12px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.75), transparent);
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
  }

.moto-office-section {
  max-height: none;
  height: auto;
  overflow: visible;
  padding-bottom: 40px;
}

.moto-office-section .parallax {
  height: auto;
  padding-bottom: 40px;
}
</style>
